import React from "react";

export const WeeklyHeader = ({ title }: { title: string }) => {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: "40px",
        height: "55px",
        borderLeft: "10px solid #F7AF3D",
        marginRight: "20px",
        marginTop: "20px",
        marginBottom: "30px",
      }}
    >
      <img
        src="/images/sentimentalgo-logo-horizontal.svg"
        alt="Sentiment Algo"
        style={{
          height: "44px",
          paddingLeft: "12px",
        }}
      />
      <div
        style={{
          fontSize: "30px",
          fontWeight: "600",
          width: "100%",
          textTransform: "uppercase",
          borderBottom: "1px solid #F7AF3D",
          fontFamily: "'Open Sans', sans-serif",
        }}
      >
        {title}
      </div>
    </div>
  );
};
